import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { MenuItems } from './shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
// Security
import { AuthenticationService } from './_services/security/authentication.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpFilter, HttpErrorFilter } from './_services/security/jwt.interceptor';
import { ProfileComponent } from './theme/_profile/profile.component';
//import { ToastrModule } from 'ngx-toastr';
//import { BasicLoginComponent } from './theme/auth/login/basic-login/basic-login.component';

////For the Google reCAPTCHA
import { FormsModule } from '@angular/forms';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from '../environments/environment';

import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    AdminComponent, 
    AuthComponent,
    BreadcrumbsComponent
 
    //BasicLoginComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    //ToastrModule.forRoot({ positionClass: 'toast-top-right', closeButton: true, preventDuplicates: true }),
    AppRoutingModule,
    SharedModule,
    FormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
   
  ],
  
  providers: [
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorFilter, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpFilter, multi: true },
    MenuItems,
    ////For the Google reCAPTCHA
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
      siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    },
   DatePipe],
  bootstrap: [AppComponent],
 
})
export class AppModule { }


